import { GetBaseUrl } from '@/functions';
import axios from 'axios';

export default axios.create({
  withCredentials: true,
  baseURL: GetBaseUrl(),
});
